module.exports = __webpack_public_path__ + "img/carbon-trophy.b8a92d7f.svg";